import {useSuspenseQuery} from "@apollo/client";

import {GQL_LAUNCHPAD_CONTENT, LaunchpadContentResponse} from "@/lib/queries/launchpad.ts";
import {AdditionalFeatures} from "@/pages/launchpad/AdditionalFeatures.tsx";
import {ChecksPanel} from "@/pages/launchpad/ChecksPanel.tsx";
import {Support} from "@/pages/launchpad/Support.tsx";

export const LaunchpadContent = () => {
  const {data} = useSuspenseQuery<LaunchpadContentResponse>(GQL_LAUNCHPAD_CONTENT);
  return (
    <div>
      <div className="white-block p-4 rounded-2 mb-3">
        <ChecksPanel
          monitoringServiceTypes={data.monitoringServiceTypes}
          serviceDefinitions={data.serviceDefinitions}
          checksUsage={data.checksUsage}
        />
      </div>
      <div className="white-block p-4 rounded-2 mb-3">
        <AdditionalFeatures
          firstDashboardID={data.firstDashboardID}
          enableStatusPages={data.user.account.enable_statuspages}
        />
      </div>
      <div className="white-block p-4 rounded-2 mb-3">
        <Support />
      </div>
    </div>
  );
};
